import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import CooperativeManagementServices from "./CooperativeManagementServices";
import { toast } from "react-toastify";
import { successAlert } from "../../Global/GlobalSlice";

export const getCooperativeReviewer = createAsyncThunk(
  "cooperativemanagement/reviewcooperativerequestquery",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData =
        await CooperativeManagementServices.getCooperativeReviewer(data);

      // if (responseData?.successful === true) {
      //   dispatch(
      //     successAlert({
      //       message: responseData?.statusMessage,
      //     })
      //   );
      // }

      console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const reducers = {
  viewData(state, action) {
    return { ...state, data: action.payload };
  },
};

export const CooperativeManagementSlice = createSlice({
  name: "management",
  initialState,
  reducers,
  extraReducers: (builder) => {
    builder
      .addCase(getCooperativeReviewer.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getCooperativeReviewer.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          data: action.payload,
        };
      })
      .addCase(getCooperativeReviewer.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
  },
});

export const { viewData } = CooperativeManagementSlice.actions;

export default CooperativeManagementSlice.reducer;
